module.exports = __webpack_public_path__ + "img/money_mouth_face.32c530ed.gif";